import { createFileRoute, redirect } from "@tanstack/react-router";


export const Route = createFileRoute("/sbop-demographic-form/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard", replace: true });
  },
});
